import { langToLocale, messages } from '@/features/i18n/constants';
import { SetLocaleContext } from '@/features/i18n/context';
import { getInitialLocale, saveLocale } from '@/features/i18n/utils';
import { PropsWithChildren, useState } from 'react';
import { IntlProvider } from 'use-intl';

export function IntlWrapper({ children }: PropsWithChildren) {
  const [locale, setLocale] = useState(getInitialLocale);

  return (
    <SetLocaleContext.Provider
      value={(newLocale) => {
        const fullLocale = langToLocale[newLocale] || newLocale;
        setLocale(fullLocale);
        saveLocale(fullLocale);
      }}
    >
      <IntlProvider messages={messages[locale] || messages['en-US']} locale={locale}>
        {children}
      </IntlProvider>
    </SetLocaleContext.Provider>
  );
}
